import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import { useCreateOrgUser } from "../services/useCreateOrgUser";

export type CreatUserForm = {
	email: string;
	role: string;
};

export default function useCreateUserForm() {
	const { translate } = useLocales();

	const schema = Yup.object().shape({
		email: Yup.string().required(translate("organization.add_his_email")),
		role: Yup.string().required(translate("organization.select_role"))
	});

	const methods = useForm<CreatUserForm>({
		resolver: yupResolver(schema),
		defaultValues: { email: "", role: "ROLE_ORG_ADMIN" }
	});

	const { onCreateUser, isLoading } = useCreateOrgUser();

	async function onSubmit({ email, role }: CreatUserForm) {
		onCreateUser(email, role);
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading
	};
}
